import { MAX_SOURCE_SUGGESTIONS } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/hooks/internal/consts.js';
import { getQueryToSearch, queryIncludesWholeWord, } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/hooks/internal/getQueryToSearch.js';
import { useSources } from '#pplx/frontend/apps/ask/sources/hooks/useSources.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useMemo } from 'react';
export const useQuerySourceSuggestionsBySourceLabel = ({ query, maxSuggestions = MAX_SOURCE_SUGGESTIONS, omittedSources = EMPTY_ARRAY, omitCometMcpSources = false, enabled, productSurface, }) => {
    const { sources: allSources, isSourceConnected, getSourceLabel, } = useSources({
        enabled,
        omitCometMcpSources,
        omittedSources,
        productSurface,
    });
    const queryToSearch = getQueryToSearch(query);
    const suggestions = useMemo(() => {
        const matches = [];
        for (const source of allSources) {
            const label = getSourceLabel(source).toLowerCase();
            if (queryIncludesWholeWord(queryToSearch, label)) {
                matches.push({ source, connected: isSourceConnected(source) });
            }
            if (matches.length >= maxSuggestions) {
                break;
            }
        }
        return matches;
    }, [queryToSearch, allSources, getSourceLabel, maxSuggestions, isSourceConnected]);
    return useMemo(() => ({ suggestions }), [suggestions]);
};
//# sourceMappingURL=useQuerySourceSuggestionsBySourceLabel.js.map